import React, { useEffect, useState } from 'react'
import SubHeader from '../general/SubHeader'

const AdminDashboard = () => {
    const [vehicle, setVehicle] = useState([]);
    const [responseMessage, setResponseMessage] = useState('');
    const [formData, setFormData] = useState({
        name: '',
        cost: '',
        seats: '',
        vehicle_image: null,
        description: ''
    })

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleFileChange = (e) => {
        setFormData((prevData) => ({
            ...prevData,
            vehicle_image: e.target.files[0], // Store the selected file
        }));
    };

    const handleAddVehicle = async (e) => {
        e.preventDefault();
        setResponseMessage('');

        const form = new FormData();
        for (let key in formData) {
            form.append(key, formData[key]);
        }

        try {
            const response = await fetch('https://apis.anvifoundation.com/omanshi/add-vehicle', {
                method: "POST",
                body: form,
            });
            if (response.ok) {
                setResponseMessage('Your vehicle has been added successfully.');
                setTimeout(() => {
                    setResponseMessage('');
                }, 3000);
                window.location.reload();
            } else {
                setResponseMessage("Failed to add vehicle. Try again later.");
                setTimeout(() => {
                    setResponseMessage('');
                }, 3000);
            }
        }
        catch (error) {
            console.error("Error:", error);
        }
    };


    // Fetch vehicles data from backend
    useEffect(() => {
        const fetchVehicles = async () => {
            try {
                const response = await fetch('https://apis.anvifoundation.com/omanshi/get-vehicle');
                const data = await response.json();

                if (response.ok) {
                    setVehicle(data); // Store the fetched sites in state
                } else {
                    console.error('Failed to fetch vehicles:', data);
                }
            } catch (error) {
                console.error('Error while fetching vehicles:', error);
            }
        };

        fetchVehicles();
    }, []); // Empty dependency array means it runs once when the component mounts


    const handleDeleteVehicle = async (vehicleId) => {
        console.log(vehicleId);
    
        try {
          const response = await fetch(`https://apis.anvifoundation.com/omanshi/delete-vehicle?vehicleId=${vehicleId}`, {
            method: "DELETE"
          });
    
          if (!response.ok) {
            throw new Error('Failed to delete vehicle');
          }
    
          setVehicle(prevVehicle => prevVehicle.filter(v => v.id !== vehicleId));
          setResponseMessage("Vehicle Deleted Successfully");
          setTimeout(() => {
            setResponseMessage('');
        }, 3000);
        } catch (error) {
          console.log(error.message);
        }
    
      }
    

    return (
        <>
            <SubHeader message="Dashboard" />

            <section className='py-5 bg-light'>
                <div className='container px-lg-5 px-3'>

                    <div className='row'>

                        <div className='col-lg-7 col-12 my-2'>
                            <div className='row'>
                            {vehicle.length > 0 ? (
                                vehicle.map((vehicles) => (
                                    <div key={vehicles.id} className='col-lg-6 col-md-6 col-12 my-2'>
                                        <div className='vehicle-area-outer'>
                                        <img src={`https://apis.anvifoundation.com/uploads/${vehicles.vehicle_image}`} className='img-fluid' style={{ height: '16em' }} alt='Exclusive Offers' />
                                        <p className='fw-semibold mt-3 mb-0 fs-5'>{vehicles.name}</p>
                                        <p className='text-muted'>Cost per km: ₹{vehicles.cost}<br />
                                            No of Seats: {vehicles.seats} Seater<br />
                                            {vehicles.description}</p>
                                        <button className='btn btn-danger' onClick={() => handleDeleteVehicle(vehicles.id)}>Delete Vehicle <i className="fa-solid fa-xmark"></i></button>
                                    </div>
                                    </div>
                                ))
                            ) : (
                                <p>No Vehicles available.</p>
                            )}
                        </div>
                        </div>


                        <div className='col-lg-5 col-12 my-2'>
                            <div className='bg-white px-4 py-4 text-center'>
                                <p className='sec-subheading'>List Vehicles for Booking</p>

                                <form className="row g-3 my-4" onSubmit={handleAddVehicle}>
                                    <div className="col-12">
                                        <input type="text" className="form-input" name='name' value={formData.name} onChange={handleChange} placeholder='Vehicle Name' required />
                                    </div>
                                    <div className="col-md-6">
                                        <input type="number" className="form-input" name='cost' value={formData.cost} onChange={handleChange} placeholder='Cost per Km' required />
                                    </div>
                                    <div className="col-md-6">
                                        <input type="number" className="form-input" name='seats' value={formData.seats} onChange={handleChange} placeholder='Number of Seats' required />
                                    </div>
                                    <div className='col-12 text-start'>
                                        <label htmlFor="Site Image" className='form-label text-muted' >Upload Vehicle Image</label>
                                        <input type="file" className="form-input" name='vehicle_image' onChange={handleFileChange} required />
                                    </div>
                                    <div className="col-12">
                                        <textarea type="text" className="form-input" name='description' value={formData.description} onChange={handleChange} placeholder='Description'></textarea>
                                    </div>

                                    <div className="col-12">
                                        <button type="submit" className="slider-btn w-100">Submit</button>
                                    </div>
                                </form>

                            </div>
                        </div>


                    </div>
                    {/* row ends */}

                </div>
            </section>

            {responseMessage && (
                <div className="response-message d-flex justify-content-between">
                    <p className='my-0 mx-auto'>{responseMessage}</p>
                    <p className='my-0 cursor-pointer' onClick={() => setResponseMessage(false)}><i className="fa-solid fa-xmark"></i></p>
                </div>)}

        </>
    )
}

export default AdminDashboard
